import { MenuProvider } from '../../../../../services/exports/Constants';

export default {
  form: {
    provider: {
      label: 'Valikon tarjoaja',
      options: {
        [null]: 'Valitse valikon tarjoaja',
        [MenuProvider.Lieferando]: 'Lieferando',
        [MenuProvider.Wolt]: 'Wolt',
        [MenuProvider.Deliveroo]: 'Deliveroo',
        [MenuProvider.UberEats]: 'Uber Eats',
        [MenuProvider.GloriaFood]: 'GloriaFood',
        [MenuProvider.Foodamigos]: 'Toinen FoodAmigos-ravintola',
        [MenuProvider.DoorDash]: 'DoorDash',
        [MenuProvider.Tabless]: 'Tabless (kassajärjestelmä)',
        [MenuProvider.Thuisbezorgd]: 'Thuisbezorgd',
        [MenuProvider.TakeawayCom]: 'Takeaway.com',
        [MenuProvider.PysznePl]: 'Pyszne.pl',
        [MenuProvider.BistroSk]: 'Bistro.sk',
        [MenuProvider.JustEat]: 'Just Eat',
      },
    },
    provider_id: {
      [MenuProvider.Lieferando]: {
        label: 'Lieferando-URL',
        placeholder: 'Ravintolan URL Lieferandossa',
      },
      [MenuProvider.Wolt]: {
        label: 'Wolt-URL',
        placeholder: 'Ravintolan URL Woltissa',
      },
      [MenuProvider.Deliveroo]: {
        label: 'Deliveroo-valikkolinkki',
        placeholder: 'https://deliveroo…/menu/city/area/restaurant',
        help: 'Avaa ravintolasi Deliveroossa ja kopioi linkki osoiterivillä.',
        error:
          'Anna Deliveroo-ravintolan valikkosivun linkki. Se näyttää tältä: https://deliveroo.co.uk/menu/city/area/restaurant-name.',
      },
      [MenuProvider.UberEats]: {
        label: 'Uber Eats -URL',
        placeholder: 'Ravintolan URL Uber Eatsissa',
      },
      [MenuProvider.GloriaFood]: {
        label: 'GloriaFood-linkki',
        placeholder: 'https://www.foodbooking.com/ordering/restaurant/menu?restaurant_uid=…',
        help: {
          ordering_page: {
            title: 'Jos käytät GloriaFoodin tilaussivua:',
            description: 'Anna foodbooking.com-tilaus-URL.',
            example: 'https://www.foodbooking.com/ordering/restaurant/menu?restaurant_uid=…',
          },
          embedded_widget: {
            title: 'Jos GloriaFood on upotettu omalle verkkosivullesi:',
            description: 'Anna sen sivun URL, jolla tilauswidget näkyy.',
            example: 'https://yourrestaurant.com/order',
          },
        },
        error: 'Anna kelvollinen linkki, joka alkaa https://.',
        back_office_error:
          'Tämä on GloriaFoodin taustajärjestelmän linkki, ei sivu, jolta asiakkaasi tilaavat. Avaa ravintolasi tilaussivu ja liitä sen linkki.',
        wrong_platform_error:
          'Tämä ei näytä GloriaFood-linkiltä. Jos käytät GloriaFoodin isännöimää sivua, anna foodbooking.com-tilaus-URL. Jos GloriaFood on upotettu omalle sivustollesi, anna sivun URL, jolla tilauswidget näkyy.',
      },
      [MenuProvider.Thuisbezorgd]: {
        label: 'Thuisbezorgd-URL',
        placeholder: 'Ravintolan URL Thuisbezorgdissa',
      },
      [MenuProvider.TakeawayCom]: {
        label: 'Takeaway.com-URL',
        placeholder: 'Ravintolan URL Takeaway.comissa',
      },
      [MenuProvider.PysznePl]: {
        label: 'Pyszne.pl-URL',
        placeholder: 'Ravintolan URL Pyszne.plissä',
      },
      [MenuProvider.BistroSk]: {
        label: 'Bistro.sk-URL',
        placeholder: 'Ravintolan URL Bistro.skssä',
      },
      [MenuProvider.JustEat]: {
        label: 'Just Eat -URL',
        placeholder: 'Ravintolan URL Just Eatissa',
      },
      [MenuProvider.DoorDash]: {
        label: 'DoorDash-liikelinkki',
        placeholder: 'https://www.doordash.com/store/…',
        help: 'Avaa ravintolasi doordash.comissa ja kopioi linkki osoiterivillä.',
        error: 'Anna DoorDash-liikkeen sivun linkki. Se alkaa https://www.doordash.com/store/.',
        store_number_error:
          'Siinä linkissä on vain liikkeen numero. Avaa ravintola doordash.comissa ja kopioi linkki, jossa on myös nimi, esim. https://www.doordash.com/store/restaurant-name-123456/.',
      },
      [MenuProvider.Foodamigos]: {
        label: 'Ravintola, josta valikko kopioidaan',
        placeholder: 'Valitse ravintola, josta valikko kopioidaan',
      },
    },
  },
};
